export default __webpack_public_path__ + "static/media/luxury_prev.74474ec5.png";